module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'b091wl28',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
